import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';

import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { InvestmentAssetMaterialService } from '../../services/investment-asset-material.service';
import { DeleteInvestmentAssetMaterial, DeleteInvestmentAssetMaterialFailure, DeleteInvestmentAssetMaterialSuccess, InvestmentAssetMaterialActionTypes, LoadInvestmentAssetMaterial, LoadInvestmentAssetMaterialFailure, LoadInvestmentAssetMaterials, LoadInvestmentAssetMaterialsFailure, LoadInvestmentAssetMaterialsSuccess, LoadInvestmentAssetMaterialSuccess, UpdateInvestmentAssetMaterial, UpdateInvestmentAssetMaterialFailure, UpdateInvestmentAssetMaterialSuccess } from '../actions/investment-asset-material.actions';
import { SummaryInvestmentAssetMaterialModel } from '../../models/summary-investment-asset-material.model';


@Injectable()
export class InvestmentAssetMaterialEffects {
  constructor(
    private actions$: Actions,
    private service: InvestmentAssetMaterialService
  ) { }

  /** 🔹 Get All */

  
  loadInvestmentAssetMaterials$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterials),
    mergeMap((action: LoadInvestmentAssetMaterials) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryInvestmentAssetMaterialModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadInvestmentAssetMaterialsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadInvestmentAssetMaterialsSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadInvestmentAssetMaterialsFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadInvestmentAssetMaterialById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(InvestmentAssetMaterialActionTypes.LoadInvestmentAssetMaterial),
        mergeMap((action: LoadInvestmentAssetMaterial) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadInvestmentAssetMaterialSuccess(response)),
            catchError(error => of(new LoadInvestmentAssetMaterialFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateInvestmentAssetMaterial$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(InvestmentAssetMaterialActionTypes.UpdateInvestmentAssetMaterial),
          mergeMap((action: UpdateInvestmentAssetMaterial) =>
            this.service.update(action.payload.investmentAsset).pipe(
              switchMap(updated => [
                new UpdateInvestmentAssetMaterialSuccess({ investmentAsset: updated }),
              ]),
              catchError(error => of(new UpdateInvestmentAssetMaterialFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteInvestmentAssetMaterial$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(InvestmentAssetMaterialActionTypes.DeleteInvestmentAssetMaterial),
          mergeMap((action: DeleteInvestmentAssetMaterial) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteInvestmentAssetMaterialSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteInvestmentAssetMaterialFailure({ error })))
            )
          )
        ));



}
